var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33171 2.5C5.11587 2.5 2.5 5.11829 2.5 8.33496V16.6683C2.5 19.8841 5.11829 22.5 8.33496 22.5H16.6683C19.8841 22.5 22.5 19.8817 22.5 16.665V8.33171C22.5 5.11587 19.8817 2.5 16.665 2.5H8.33171ZM18.3333 5.83333C18.7933 5.83333 19.1667 6.20667 19.1667 6.66667C19.1667 7.12667 18.7933 7.5 18.3333 7.5C17.8733 7.5 17.5 7.12667 17.5 6.66667C17.5 6.20667 17.8733 5.83333 18.3333 5.83333ZM12.5 7.5C15.2575 7.5 17.5 9.7425 17.5 12.5C17.5 15.2575 15.2575 17.5 12.5 17.5C9.7425 17.5 7.5 15.2575 7.5 12.5C7.5 9.7425 9.7425 7.5 12.5 7.5ZM12.5 9.16667C11.6159 9.16667 10.7681 9.51786 10.143 10.143C9.51786 10.7681 9.16667 11.6159 9.16667 12.5C9.16667 13.3841 9.51786 14.2319 10.143 14.857C10.7681 15.4821 11.6159 15.8333 12.5 15.8333C13.3841 15.8333 14.2319 15.4821 14.857 14.857C15.4821 14.2319 15.8333 13.3841 15.8333 12.5C15.8333 11.6159 15.4821 10.7681 14.857 10.143C14.2319 9.51786 13.3841 9.16667 12.5 9.16667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.7eb59b8e521eaee8d7dd9ec524cf80d6.svg";
export { ForwardRef as ReactComponent };